if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.dpx-main-product');
      this.productInfo = this.productSection.querySelectorAll('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.submitBtn = this.querySelector("button.btn");
      this.price = this.querySelector(".price__current");
      this.variants = this.querySelectorAll(".card__options--option");

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    // NEW: single place to toggle the class AND update the iframe
    updatePodiumPosition() {
      const atBottom = document.body.classList.contains('scrolled-to-bottom');
      const stickyVisible = !this.classList.contains('sticky-atc-panel--out');

      const podiumIframe = document.getElementById('podium-bubble');
      const podiumPromptIframe = document.getElementById('podium-prompt');

      const shouldOffset = stickyVisible && !atBottom;

      if (podiumIframe) {
        podiumIframe.classList.toggle('podium-sticky-offset', shouldOffset);
      }
      if (podiumPromptIframe) {
        podiumPromptIframe.classList.toggle('podium-sticky-offset', shouldOffset);
      }
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            // 'this' here is the StickyAtcPanel instance because the arrow
            // function inherits 'this' from bindEvents, which is called on
            // the instance via this.bindEvents()
            this.setStickyActive(entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo[this.productInfo.length - 1] && theme.mediaMatches.md) {
            this.setStickyActive(entry.isIntersecting);
          }
        });
      });

      if (this.productForm) {
        observer.observe(this.productForm);

        if (theme.settings.afterAtc !== 'no-js') {
          this.productForm.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }

      if (this.productInfo[this.productInfo.length - 1]) {
        observer.observe(this.productInfo[this.productInfo.length - 1]);
      }

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
      document.addEventListener('on:variant:change', this.onVariantChange.bind(this));
      document.addEventListener('on:cart:add', this.handleAddSuccess.bind(this));

      // Watch for the PR image modal opening/closing
      const prObserver = new MutationObserver(() => {
        const modalOpen = !!document.querySelector('.pr-media-modal');
        this.classList.toggle('sticky-atc-panel--hidden-for-pr', modalOpen);

        const podiumIframe = document.getElementById('podium-bubble');
        const podiumPromptIframe = document.getElementById('podium-prompt');

        if (podiumIframe) {
          podiumIframe.classList.toggle('sticky-atc-panel--hidden-for-pr', modalOpen);
        }
        if (podiumPromptIframe) {
          podiumPromptIframe.classList.toggle('sticky-atc-panel--hidden-for-pr', modalOpen);
        }
      });

      prObserver.observe(document.body, { childList: true, subtree: true });
    }

    static handleScroll() {
      const atBottom = window.scrollY + window.innerHeight + 100 > document.body.scrollHeight;
      document.body.classList.toggle('scrolled-to-bottom', atBottom);

      // Delegate to the instance method so all logic stays in one place
      const panel = document.querySelector('sticky-atc-panel');
      if (panel) panel.updatePodiumPosition();
    }

    setStickyActive(isActive) {
      this.classList.toggle('sticky-atc-panel--out', isActive);
      this.updatePodiumPosition();
    }

    onVariantChange(evt) {
      if (evt.detail.variant) {
        const variant = evt.detail.variant;
        const data = JSON.parse(document.getElementById("option-json").textContent);

        this.price.innerHTML = data.formatted[variant.id].price;
        this.variants.forEach((option, index) => {
          option.querySelector(".option__value").innerHTML = variant.options[index];
        });
      }
    }

    handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form' || this.submitBtn.getAttribute('aria-disabled') === 'true') return;
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');
    }

    handleAddSuccess(evt) {
      this.submitBtn.classList.add('is-success');
      this.submitBtn.removeAttribute('aria-disabled');
      setTimeout(() => {
        this.submitBtn.classList.remove('is-loading');
        this.submitBtn.classList.remove('is-success');
      }, 1400);
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}